import { useAlert } from '../../../AlertProvider';
import { useQueryClient } from '@tanstack/react-query';
import { useEditableSectionsContext } from '../../../EditableSection';

export const useUpdateSettingsHandlers = (userId: string, formTitle: string) => {
  const { setEditKey } = useEditableSectionsContext();
  const queryClient = useQueryClient();
  const alert = useAlert();

  const onFormSubmitSuccess = async (invalidateQueries = false) => {
    alert.success(`${formTitle} updated`);
    setEditKey(null);
    if (invalidateQueries) {
      await queryClient.invalidateQueries({ queryKey: [ 'user', userId ] });
    }
  };

  const onFormSubmitError = () => {
    alert.error(`There was a problem updating your ${formTitle}. Try again or contact help@joinuplift.co`);
  };

  return { onFormSubmitSuccess, onFormSubmitError };
};
